import { Box, Grid, MenuItem, Select, FormControl } from "@mui/material";
import GlobalSearch from "../../utility/GlobalSearch/GlobalSearch";
import { GlobalTable } from "../../utility/globalTable";
import { transactionColumns } from "./utils/transactionColumns";
import { useBillingStore } from "../../../store/billingStore";
import { useShallow } from "zustand/react/shallow";
import { useMemo, useState } from "react";
import { billingSubscriptionTransaction } from "../../../models/axiosModel";
import { getTransactionAmount } from "./utils/transactionUtils";

import styles from "../../../assets/styles/componentStyles/billingStyles/billing.module.scss";
import { toCapitalizedCase } from "../../../utils/constants";

const ALL_STATUSES = "";

const BillingSection = () => {

    const [search, setSearch] = useState("");
    const [selectedTransactionStatus, setSelectedTransactionStatus] = useState(ALL_STATUSES);

    const { billingSubscriptionDetails, transactionStatuses } = useBillingStore(useShallow((state) => ({
        billingSubscriptionDetails: state.billingSubscriptionDetails,
        transactionStatuses: state.transactionStatuses,
    })));

    const filteredTransactions = useMemo(() => {
        const query = search.trim().toLowerCase();
        const transactionRows = billingSubscriptionDetails?.transactions || [];

        const searchableFields: (keyof billingSubscriptionTransaction)[] = [
            "transaction_paid_at",
            "transaction_description",
            "transaction_status",
            "transaction_amount",
        ];

        return transactionRows.filter((transaction) => {
            const matchesStatus =
                !selectedTransactionStatus ||
                transaction.transaction_status?.toLowerCase() === selectedTransactionStatus.toLowerCase();

            if (!matchesStatus) {
                return false;
            }

            if (!query) {
                return true;
            }

            const matchesField = searchableFields.some((field) =>
                transaction[field]?.toLowerCase().includes(query)
            );
            const formattedAmount = getTransactionAmount(transaction).toLowerCase();

            return matchesField || formattedAmount.includes(query);
        });
    }, [search, billingSubscriptionDetails?.transactions, selectedTransactionStatus]);

    return (
        <Grid container spacing={2}>

            <Grid item xs={12}>
                <Box className={styles.searchContainer}>
                    <Box className={styles.searchInput}>
                        <GlobalSearch
                            size="small"
                            placeholder="Search transaction..."
                            value={search}
                            onChange={(e) => { setSearch(e.target.value) }}
                            fullWidth
                        />
                    </Box>

                    <FormControl size="small" className={styles.selectInput}>
                        <Select
                            value={selectedTransactionStatus}
                            onChange={(e) => { setSelectedTransactionStatus(e.target.value) }}
                            displayEmpty
                            MenuProps={{
                                PaperProps: {
                                    className: styles.selectMenu,
                                },
                            }}
                        >
                            <MenuItem value={ALL_STATUSES}>
                                All
                            </MenuItem>

                            {transactionStatuses?.map((status) => (
                                <MenuItem
                                    key={status.billing_subscription_transaction_status_id}
                                    value={status.billing_subscription_transaction_status_name}
                                >
                                    {toCapitalizedCase(status.billing_subscription_transaction_status_name)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className={styles.transactionTable}>
                    <GlobalTable
                        headerList={transactionColumns}
                        rowData={filteredTransactions}
                    />
                </Box>
            </Grid>

        </Grid>
    )
}

export default BillingSection;
